import React from 'react';
import { TrialInfoProps } from '@sharefiledev/billing-pilet-sdk';
import { Spin } from 'antd';

const LazyTrialInformationBanner = React.lazy(() => import('./TrialInformationBanner'));
export const AsyncTrialInformationBanner: React.FC<TrialInfoProps> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyTrialInformationBanner {...props} />
	</React.Suspense>
);
